import React, {Component} from "react";


export default class CitationEvidence extends Component {



    render() {
        return (
            <section className="evidence">
                <div className="evidence__inner">
                    <div className="evidence__left evidence__item">
                        <p className="evidence__headline">Supporting Evidence</p>
                        <div className="evidence__table">
                            <div className="evidence-category">
                                <div className="evidence-category__item evidence-category__item--active">Theoretical</div>
                                <div className="evidence-category__item">Psychological</div>
                                <div className="evidence-category__item">Mediacal</div>
                                <div className="evidence-category__item">Physiological</div>
                                <div className="evidence-category__item">Cross-Cultural</div>
                                <div className="evidence-category__item">Genetic</div>
                                <div className="evidence-category__item">Phylogenetic</div>
                                <div className="evidence-category__item">Hunter-Gatherer</div>
                            </div>
                            <div className="evidence-score">
                                <div className="evidence-score__item">
                                    <div className="evidence-score__value">
                                        <span className="evidence-score__count">60</span>
                                        <span className="evidence-score__text">/100</span>
                                    </div>
                                    <div className="evidence-score__submitted-by">
                                        <span className="evidence-score__label">Submitted by</span>
                                        <span className="evidence-score__person">djglass</span>
                                    </div>
                                </div>
                            </div>
                            <div className="final-score">
                        <span className="final-score__text">
                            Theoretical Support SubScore: <span className="final-score__value">65</span>/100
                        </span>
                            </div>
                        </div>
                    </div>
                    <div className="evidence__right evidence__item">
                        <p className="evidence__headline">Challenging Evidence</p>
                        <div className="evidence__table">

                            <div className="evidence-category">
                                <div className="evidence-category__item evidence-category__item--active" data-score="theoretical">Theoretical</div>
                                <div className="evidence-category__item" data-score="psychological">Psychological</div>
                                <div className="evidence-category__item">Mediacal</div>
                                <div className="evidence-category__item">Physiological</div>
                                <div className="evidence-category__item">Cross-Cultural</div>
                                <div className="evidence-category__item">Genetic</div>
                                <div className="evidence-category__item">Phylogenetic</div>
                                <div className="evidence-category__item">Hunter-Gatherer</div>
                            </div>


                            <div className="evidence-score active" data-score="theoretical">
                                <div className="evidence-score__item">
                                    <div className="evidence-score__value">
                                        <span className="evidence-score__count">60</span>
                                        <span className="evidence-score__text">/100</span>
                                    </div>
                                    <div className="evidence-score__submitted-by">
                                        <span className="evidence-score__label">Submitted by</span>
                                        <span className="evidence-score__person">djglass</span>
                                    </div>
                                </div>
                                <div className="evidence-score__item">
                                    <div className="evidence-score__value">
                                        <span className="evidence-score__count">60</span>
                                        <span className="evidence-score__text">/100</span>
                                    </div>
                                    <div className="evidence-score__submitted-by">
                                        <span className="evidence-score__label">Submitted by</span>
                                        <span className="evidence-score__person">djglass</span>
                                    </div>
                                </div>
                            </div>
                            <div className="evidence-score" data-score="psychological">
                                <div className="evidence-score__item">
                                    <div className="evidence-score__value">
                                        <span className="evidence-score__count">60</span>
                                        <span className="evidence-score__text">/100</span>
                                    </div>
                                    <div className="evidence-score__submitted-by">
                                        <span className="evidence-score__label">Submitted by</span>
                                        <span className="evidence-score__person">djglass</span>
                                    </div>
                                </div>
                                <div className="evidence-score__item">
                                    <div className="evidence-score__value">
                                        <span className="evidence-score__count">60</span>
                                        <span className="evidence-score__text">/100</span>
                                    </div>
                                    <div className="evidence-score__submitted-by">
                                        <span className="evidence-score__label">Submitted by</span>
                                        <span className="evidence-score__person">djglass</span>
                                    </div>
                                </div>
                            </div>




                            <div className="final-score">
                        <span className="final-score__text">
                            Genetic Challenging SubScore: <span className="final-score__value">15</span>/100
                        </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
};











// const CitationEvidence = () => {
//
//
//     onSwitchCategory = (id) =>{
//         console.log('Toggle Done', id);
//     };
//
//     return (
//         <section className="evidence">
//             <div className="evidence__inner">
//                 <div className="evidence__left">
//                     <p className="evidence__headline">Supporting Evidence</p>
//                     <div className="evidence__table">
//                         <div className="evidence-category">
//                             <div className="evidence-category__item evidence-category__item--active">Theoretical</div>
//                             <div className="evidence-category__item">Psychological</div>
//                             <div className="evidence-category__item">Mediacal</div>
//                             <div className="evidence-category__item">Physiological</div>
//                             <div className="evidence-category__item">Cross-Cultural</div>
//                             <div className="evidence-category__item">Genetic</div>
//                             <div className="evidence-category__item">Phylogenetic</div>
//                             <div className="evidence-category__item">Hunter-Gatherer</div>
//                         </div>
//                         <div className="evidence-score">
//                             <div className="evidence-score__item">
//                                 <div className="evidence-score__value">
//                                     <span className="evidence-score__count">60</span>
//                                     <span className="evidence-score__text">/100</span>
//                                 </div>
//                                 <div className="evidence-score__submitted-by">
//                                     <span className="evidence-score__label">Submitted by</span>
//                                     <span className="evidence-score__person">djglass</span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="final-score">
//                         <span className="final-score__text">
//                             Theoretical Support SubScore: <span className="final-score__value">65</span>/100
//                         </span>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="evidence__right">
//                     <p className="evidence__headline">Challenging Evidence</p>
//                     <div className="evidence__table">
//
//                         <div className="evidence-category">
//                             <div className="evidence-category__item evidence-category__item--active" data-soce="theoretical" onClick={onSwitchCategory}>Theoretical</div>
//                             <div className="evidence-category__item" data-score="psychological">Psychological</div>
//                             <div className="evidence-category__item">Mediacal</div>
//                             <div className="evidence-category__item">Physiological</div>
//                             <div className="evidence-category__item">Cross-Cultural</div>
//                             <div className="evidence-category__item">Genetic</div>
//                             <div className="evidence-category__item">Phylogenetic</div>
//                             <div className="evidence-category__item">Hunter-Gatherer</div>
//                         </div>
//
//
//                         <div className="evidence-score active" data-score="theoretical">
//                             <div className="evidence-score__item">
//                                 <div className="evidence-score__value">
//                                     <span className="evidence-score__count">60</span>
//                                     <span className="evidence-score__text">/100</span>
//                                 </div>
//                                 <div className="evidence-score__submitted-by">
//                                     <span className="evidence-score__label">Submitted by</span>
//                                     <span className="evidence-score__person">djglass</span>
//                                 </div>
//                             </div>
//                             <div className="evidence-score__item">
//                                 <div className="evidence-score__value">
//                                     <span className="evidence-score__count">60</span>
//                                     <span className="evidence-score__text">/100</span>
//                                 </div>
//                                 <div className="evidence-score__submitted-by">
//                                     <span className="evidence-score__label">Submitted by</span>
//                                     <span className="evidence-score__person">djglass</span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="evidence-score" data-score="psychological">
//                             <div className="evidence-score__item">
//                                 <div className="evidence-score__value">
//                                     <span className="evidence-score__count">60</span>
//                                     <span className="evidence-score__text">/100</span>
//                                 </div>
//                                 <div className="evidence-score__submitted-by">
//                                     <span className="evidence-score__label">Submitted by</span>
//                                     <span className="evidence-score__person">djglass</span>
//                                 </div>
//                             </div>
//                             <div className="evidence-score__item">
//                                 <div className="evidence-score__value">
//                                     <span className="evidence-score__count">60</span>
//                                     <span className="evidence-score__text">/100</span>
//                                 </div>
//                                 <div className="evidence-score__submitted-by">
//                                     <span className="evidence-score__label">Submitted by</span>
//                                     <span className="evidence-score__person">djglass</span>
//                                 </div>
//                             </div>
//                         </div>
//
//
//
//
//                         <div className="final-score">
//                         <span className="final-score__text">
//                             Genetic Challenging SubScore: <span className="final-score__value">15</span>/100
//                         </span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     )
// };
//
// export default CitationEvidence
